export default "__VITE_ASSET__Ccd1fkvO__"